// ./components/DownloadCard/index.jsx
import { motion } from 'framer-motion';
import { useState } from 'react';
import { FaInfoCircle, FaTerminal } from 'react-icons/fa';
import CopyButton from '../../../components/CopyButton';
import DownloadButton from '../DownloadButton';
import { useVersion } from '../VersionProvider';
import './style.scss';

const DownloadCard = ({ os, isActive }) => {
  const { version, loading } = useVersion();
  const [hoveringIndex, setHoveringIndex] = useState(null);

  const getFormattedFilename = (filename) => {
    return filename.replace('{version}', version || 'latest');
  };

  const handleDownload = (versionData) => {
    if (!version) return;

    const filename = getFormattedFilename(versionData.filename);
    const url = versionData.url.replace(/{version}/g, version);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.setAttribute('data-version', version);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <motion.div
      className={`d-flex flex-column download-card ${isActive ? 'active' : ''}`}
      whileHover={{ y: -5 }}
    >
      <div className="card-header">
        <os.icon size={32} style={{ color: os.color }} />
        <h3 className="text-primary">
          {os.name}
          {version && <span className="version-tag">v{version}</span>}
        </h3>
      </div>

      <div className="versions-list">
        {os.versions.map((versionData, index) => (
          <motion.button
            key={index}
            className="version-item"
            whileHover={{ scale: 1.02 }}
            onHoverStart={() => setHoveringIndex(index)}
            onHoverEnd={() => setHoveringIndex(null)}
            onClick={() => !loading && handleDownload(versionData)}
            disabled={loading}
            type="button"
          >
            <div className="version-info">
              <h4 className="text-primary">{versionData.name}</h4>
              <p>
                Version {version || 'latest'} • {versionData.size}
              </p>
            </div>
            <DownloadButton
              disabled={loading}
              filename={getFormattedFilename(versionData.filename)}
              onClick={(e) => {
                e.stopPropagation();
                handleDownload(versionData);
              }}
              isHovering={hoveringIndex === index}
            />
          </motion.button>
        ))}
      </div>

      <div className="installation-guide mt-auto">
        <h5 className="text-primary">
          <FaInfoCircle className="me-2" />
          Installation Guide
        </h5>
        <ul>
          {os.instructions.map((instruction, index) => (
            <li key={index}>
              {typeof instruction === 'string' ? (
                <div className="instruction-step">
                  <span className="step-number">{index + 1}</span>
                  {instruction}
                </div>
              ) : instruction.type === 'command' ? (
                <div className="command-block">
                  <p className="command-description">
                    {instruction.description}
                  </p>
                  <div className="code-block">
                    <FaTerminal className="me-2" />
                    <code>
                      {instruction.text.replace(
                        '{version}',
                        version || 'latest'
                      )}
                    </code>
                    <CopyButton
                      text={instruction.text.replace(
                        '{version}',
                        version || 'latest'
                      )}
                    />
                  </div>
                </div>
              ) : (
                <div className="note-block">
                  <FaInfoCircle className="me-2" />
                  {instruction.text}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

export default DownloadCard;
